<template>
	<div class="cart room__block">
		<section class="cart__header">
			<div class="cart__back">
				<img
				class="global_pointer"
					@click.stop="back"
					:src="require('@/assets/imgs/cart/back.png')"
				/>
			</div>
		</section>
		<section class="cart__body">
			<template v-if="list.length > 0">
				<div
					v-for="item in list"
					:key="item.id"
					@touchstart.stop="touchstartHandle"
					@touchend.stop="touchendHandle(item, $event)"
					:class="['cart__item', { cart__show_del: item.showDel }, {'cart__item--disabled': item.checkboxDisabled}]"
				>
					<div class="cart__block">
						<div
							:class="[
								'cart__checkbox',
								!item.checkboxDisabled ?( item.checked ? 'cart__checkbox-checked' : 'cart__checkbox-unchecked'): '',
							]"
							@click="checkGood(item)"
						></div>
						<img class="cart__poster" :src="item.coverImgKey.url" />
						<div class="cart__info">
							<div class="cart__title">{{ item.name }}</div>
							<div class="cart__sku">
								{{ getSKUText(item.merchandiseOptions) }}
							</div>
							<div class="cart__cost">
								<div class="cart__money">
									{{ item.priceMoney.symbol
									}}{{
										$currencyFormatter(
											item.priceMoney.number
										)
									}}
									
									<span
										class="mini_shelf_price"
										v-if="
											item.shelfAmountMoney && item.shelfAmountMoney.symbol &&  Number(item.shelfAmountMoney.number) > 0
										"
									>
										&nbsp;({{
											`${
												item.shelfAmountMoney.symbol
											}${$currencyFormatter(
												item.shelfAmountMoney.number
											)}`
										}})
									</span>
								</div>
							</div>

							<div class="cart__num_area" v-if="item.status !== 0">
								<div class="cart__sub" @click="sub(item)">
									-
								</div>
								<div class="cart__num">{{ item.buyNum }}</div>
								<div class="cart__add" @click="add(item)">
									+
								</div>
							</div>
						</div>
					</div>
					<div
						:class="[
							'cart__del',
							item.showDel ? 'cart__del-show' : 'cart__del-hid',
						]"
						@click="delGood(item.id)"
					>
						<img :src="require('@/assets/imgs/cart/del.png')" />
					</div>
					<p class="goods-tips" :class="{'__invalid': item.status === 0}">
						<template v-if="item.status === 0">
							{{ $t('message.goods.outOfStock') }}
						</template>
						<template v-else>
							{{ $i18n.locale==='en'?`This product will be shipping from a different location. Please remove this item from this order and check out separately.`: `该商品为不同发货仓，暂不可一起下单` }}
						</template>
					</p>
				</div>
			</template>
			<div class="cart__empty" v-else>
				<img :src="require('@/assets/imgs/cart/empty.png')" />
				<p>{{ $t("message.shop.cart.empty") }}</p>
			</div>
		</section>
		<section class="cart__footer">
			<div class="cart__footer_inner">
				<div class="cart__footer_all">
					<div
						:class="[
							'cart__checkbox_all',
							{ 'cart__checkbox-checked': checkAllFlag },
						]"
						@click="checkAll"
					></div>
					<span>{{ $t("message.cart.selectAll") }}</span>
				</div>
				<div class="cart__footer_total"></div>
			</div>
			<div class="cart__footer_action" @click="toOrder">
				<span>{{ $t("message.cart.createOrder") }}</span>
				<span v-if="checkedList.length > 0"
					>（{{ checkedList.length }}）</span
				>
			</div>
		</section>
	</div>
</template>

<script>
import api from "@/api/api_list.js";
import { GetSlideDirection } from "@/utils";
let touchStartX, touchStartY;
export default {
	data() {
		return {
			list: [],
			checkedList: [],
			checkAllFlag: false,
		};
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.getList();
		},
		async getList() {
			await api.list_cart().then((res) => {
				let arr = [];
				if (res.result && res.result.length > 0) {
					arr = res.result;
					arr.forEach((i) => {
						i.isShopifyUsd = false;
						i.checkboxDisabled = false;
						
						// 商品已失效
						if( i.status === 0 ){
							i.checkboxDisabled = true;
						}

						// source(5: shopify商品)  shopify商品和其他商品不可同时下单
						if (i.source === 5) {
							i.isShopifyUsd = true;
						}
						i.showDel = false;
					});
				}
				this.list = arr;
			});
		},
		getSKUText(obj) {
			return obj
				.reduce((acc, cur) => {
					return (
						acc + ` ${cur.attributeNameEn}：${cur.attributeValueEn}`
					);
				}, "")
				.substring(1);
		},
		sub(good) {
			if (good.buyNum === 1)
				return this.$toast(this.$t("message.cart.only"));
			good.buyNum--;
		},
		add(good) {
			good.buyNum++;
		},

		refreshGoodsDisableTips(){
			if( this.checkedList.length == 0  ){
				this.list.forEach(item=>{
					if( item.status === 0 ){
						item.checkboxDisabled = true;
					}else{
						item.checkboxDisabled = false;
					}
				});
			}else{
				let __first = this.checkedList[0];
				if( __first ){
					this.list.forEach(item=>{
						if( item.status === 0 ){
							item.checkboxDisabled = true;
						}else{
							item.checkboxDisabled = __first.isShopifyUsd === item.isShopifyUsd?false: true
						}
					})
				}
			}
		},

		checkGood(item) {

			if (!item.checked) {
				item.checked = true;
				this.checkedList.push(item);
			} else {
				item.checked = false;
				let delIndex = this.checkedList.findIndex(
					(good) => good.id == item.id
				);
				this.checkedList.splice(delIndex, 1);
			}

			this.refreshGoodsDisableTips();

			// 可以选中的商品集合
			let selectableList = this.list.filter( item=>{
				return !item.checkboxDisabled
			});

			this.checkAllFlag = selectableList.length === this.checkedList.length;
		},
		checkAll() {

			if ( this.checkAllFlag ) {

				this.list.forEach((good) => {
					// 商品已失效
					if( good.status === 0 ){
						good.checkboxDisabled = true;
					}else{
						good.checkboxDisabled = false;
					}
					good.checked = false;
				});

				this.checkedList = [];

				this.checkAllFlag = false;
			} else {
				
				// 为了逻辑好处理，手动让选中第一个
				if( this.checkedList.length == 0 ){

					// 查找第一个未失效的商品
					for(let i=0; i<this.list.length ; i++){	
						if( this.list[i].status !== 0 ){
							this.checkGood( this.list[i] );	
							break;
						}
					}
					if( this.checkedList.length == 0 ){
						return;
					}
				}


				if( !this.checkAllFlag ){

					let selectableList =[];
					this.list.forEach((good) => {
						if( !good.checkboxDisabled ){
							good.checked = true;
							selectableList.push( good );
						}
					});
					this.checkedList = selectableList;
				}

				this.checkAllFlag = true;
			}

			// this.checkAllFlag = !this.checkAllFlag;
		},
		toOrder() {
			if (this.checkedList.length === 0) return;
			this.checkedList.forEach((i) => {
				i.merchandiseImg = i.coverImgKey;
				i.merchandiseName = i.name;
				i.miniAmountMoney = i.priceMoney;
				delete i.skuAttrs;
			});
			this.$emit("buy", this.checkedList);
		},
		back() {
			this.$emit("cartBack");
		},
		touchstartHandle(ev) {
			touchStartX = ev.touches[0].pageX;
			touchStartY = ev.touches[0].pageY;
		},
		touchendHandle(item, ev) {
			let endX = ev.changedTouches[0].pageX;
			let endY = ev.changedTouches[0].pageY;
			let direction = GetSlideDirection(
				touchStartX,
				touchStartY,
				endX,
				endY
			);
			if (![3, 4].includes(direction)) return;
			switch (direction) {
				case 3:
					item.showDel = true;
					break;
				case 4:
					item.showDel = false;
					break;
				default:
					break;
			}
			console.log("item.showDel::", item.showDel);
		},
		async delGood(id) {
			await api
				.delete_cart_sku({
					ids: [id],
				})
				.then( async ({ code }) => {
					await this.getList();
					// 删除后，以前选中的现在全部不选中
					this.checkAllFlag = false;
					this.checkedList = [];
				})
				.catch((err) => {
					this.$toast("error");
				});
		},
	},
};
</script>

<style lang="less" scoped>

.cart__item{
	&.cart__item--disabled{
		.goods-tips{
			display: block;
		}
		.cart__checkbox{
			visibility: hidden;
		}
	}
}

.goods-tips{
	display: none;
	padding-bottom: 10px;
	color: red;
	font-size: 12px;
	&.__invalid{
		position: absolute;
		left: 40px;
		bottom: 32.5px;
		background: rgba(0, 0, 0, 0.5);
		width: 87px;
		text-align: center;
		height: 10px;
		line-height: 20px;
		color: #fff;
	}
}
.mini_shelf_price {
	color: #aaa;
	font-size: 12px;
	font-weight: normal;
	font-family: "PingFang SC";
}
.show {
	transform: translateX(-50px);
}
.word-warp() {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.scroll-box() {
	scrollbar-width: none;
	-ms-overflow-style: none;
	overflow-x: hidden;
	overflow-y: auto;
	&::-webkit-scrollbar {
		display: none;
	}
}
.title-warp() {
	text-overflow: -o-ellipsis-lastline;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}
@footerHeight: 48px;
@delWidth: 72px;
.cart {
	position: absolute;
	left: 0;
	top: 0;
	overflow: hidden;
	width: 100%;
	height: 100%;
	background-color: #f4f7f7;
	display: flex;
	flex-direction: column;
	align-content: center;
	&__body {
		.scroll-box();
		flex: 1;
		box-sizing: border-box;
		padding: 0 12px;
		font-weight: normal;
	}
	&__back {
		box-sizing: border-box;
		padding-top: 8px;
		padding-left: 6px;
		text-align: left;
		height: 34px;
		img {
			width: 28px;
			height: 28px;
		}
	}
	&__item {
		width: 351px;
		min-height: 131px;
		margin-top: 12px;
		position: relative;
		border-radius: 8px;
		overflow: hidden;
		transition: transform 0.2s;
		background: #FFF;
	}
	&__block {
		width: 351px;
		height: 100%;
		background: #ffffff;
		display: flex;
		align-items: flex-start;
	}
	&__del {
		position: absolute;
		top: 0;
		width: @delWidth;
		height: 100%;
		background: #ca2f41;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: width 0.2s;
		overflow-x: hidden;
		border-top-right-radius: 8px;
		border-bottom-right-radius: 8px;
		> img {
			width: 16px;
			height: 16px;
		}
		&-hid {
			right: -@delWidth;
		}
		&-show {
			right: 0;
		}
	}
	&__show_del {
		width: 351px + @delWidth;
		border-radius: 0;
		transform: translateX(-@delWidth);
	}
	&__poster {
		width: 87px;
		height: 87px;
		margin-top: 12px;
		margin-left: 12px;
		object-fit: cover;
	}
	&__checkbox {
		width: 16px;
		height: 16px;
		box-sizing: border-box;
		margin-top: 44px;
		margin-left: 12px;
		&-unchecked {
			border: 1px solid #a4a4a4;
			border-radius: 50%;
		}
		&-checked {
			background: url("../../assets/imgs/cart/checked.png") center center
				no-repeat;
			background-size: 100% 100%;
		}
	}
	&__checkbox_all {
		width: 16px;
		height: 16px;
		box-sizing: border-box;
		margin-right: 1px;
		border: 1px solid #a4a4a4;
		border-radius: 50%;
	}
	&__info {
		flex: 1;
		height: 100%;
		box-sizing: border-box;
		padding: 0 16px 0 12px;
	}
	&__title {
		.title-warp();
		max-width: 196px;
		height: 36px;
		line-height: 18px;
		font-size: 13px;
		color: #161a1a;
		margin-top: 12px;
		text-align: left;
	}
	&__sku {
		width: 196px;
		height: 21px;
		margin-top: 8px;
		line-height: 21px;
		background: #f4f7f7;
		border-radius: 3px;
		font-size: 12px;
		color: #a4a4a4;
		text-align: left;
		box-sizing: border-box;
		padding-left: 6px;
	}
	&__cost {
		margin-top: 16px;
		width: 196px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	&__money {
		font-size: 13px;
		font-weight: 600;
		color: #b4282d;
	}
	&__num_area {
		width: 72.5px;
		height: 22px;
		background: #ffffff;
		border-radius: 3.5px;
		border: 0.5px solid rgba(0, 0, 0, 0.1);
		display: flex;
		float: right;
		margin-bottom: 10px;
	}
	&__sub,
	&__add {
		width: 22px;
		height: 22px;
		line-height: 22px;
		text-align: center;
		color: #d8d8d8;
	}
	&__sub {
		border-right: 1px solid rgba(0, 0, 0, 0.1);
	}
	&__add {
		border-left: 1px solid rgba(0, 0, 0, 0.1);
	}
	&__num {
		flex: 1;
		height: 22px;
		line-height: 22px;
		font-size: 11.5px;
		color: #212138;
	}
	&__footer {
		width: 100%;
		height: @footerHeight;
		background: #ffffff;
		display: flex;
		align-items: center;
		&_inner {
			flex: 1;
			display: flex;
			justify-content: space-between;
			align-items: center;
		}
		&_all {
			flex: 1;
			height: 18px;
			display: flex;
			// justify-content: space-between;
			align-items: center;
			margin-left: 16px;
			font-size: 13px;
			font-weight: 500;
			color: #a4a4a4;
		}
		&_total {
			margin-right: 8px;
			font-size: 14px;
			color: #161a1a;
		}
		&_action {
			height: @footerHeight;
			line-height: @footerHeight;
			width: 125px;
			background: #333333;
			font-size: 16px;
			font-weight: normal;
			color: #ffffff;
		}
	}
	&__empty {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		img {
			width: 168px;
			height: 168px;
		}
		p {
			text-align: center;
			font-size: 14px;
			font-weight: normal;
			color: #999999;
			line-height: 20px;
		}
	}
}
</style>
